import { closeDialog, openDialog } from 'src/redux/slices/alertDialog'
import { getLogoutEvent } from 'src/services/logout'
import { setFilter } from 'src/redux/slices/eLearning/learningPath/list'
import { E_LEARNING_STATUS } from 'src/constants/eLearning'
import { path } from 'src/constants/path'
import { clearFileTicket } from 'src/utils/fileTicket'

export const handleClick = (event, setAnchorEl) => {
  setAnchorEl(event.currentTarget)
}

export const handleClose = (setAnchorEl) => {
  setAnchorEl(null)
}

const userType = {
  AGENT: 'Agent',
  STAFF: 'Staff',
  PROSPECT: 'Prospect',
}

const LOCAL = ['DEV', 'LOCAL']

export const handleLogout =
  (auth, type, location = '/login') =>
  (dispatch) => {
    dispatch(
      openDialog({
        title: 'ออกจากระบบ',
        message: ['คุณต้องการออกจากระบบ?'],
        buttonLeft: { label: 'ยกเลิก' },
        buttonRight: {
          label: 'ยืนยัน',
          handleClick: () => dispatch(handleOnLogout(auth, type, location)),
        },
      })
    )
  }

export const handleOnLogout =
  (auth, type, location = '/login') =>
  async (dispatch) => {
    await dispatch(getLogoutEvent())
    dispatch(handleConfirmLogout(auth, type, location))
    dispatch(closeDialog())
  }

export const handleConfirmLogout =
  (auth, type, location = '') =>
  (dispatch) => {
    clearFileTicket()
    const classUuid = localStorage.getItem('classUuid')
    window.localStorage.clear()
    window.sessionStorage.clear()
    localStorage.setItem('classUuid', classUuid)

    const { __env__: env } = window

    const redirectTo = {
      post_logout_redirect_uri: `${env.REACT_APP_APP_URL}${location}`,
    }

    switch (type) {
      case userType.AGENT:
        dispatch(handleRedirectAgent(auth, redirectTo, env))
        break
      case userType.STAFF:
        dispatch(handleRedirectStaff(env, auth, redirectTo))
        break
      default:
        dispatch(closeDialog())
        auth.signoutRedirect(redirectTo)
        break
    }
  }

export const handleRedirectAgent = (auth, redirectTo, env) => (dispatch) => {
  if (!LOCAL.includes(env.ENV)) {
    window.location.href = `${window.__env__.REACT_APP_LOGOUT_URL_B2A}`
    return false
  } else {
    dispatch(closeDialog())
    auth.signoutRedirect(redirectTo)
    window?.location?.reload()
  }
}

export const handleRedirectStaff = (env, auth, redirectTo) => (dispatch) => {
  if (!LOCAL.includes(env.ENV)) {
    window.location.href = `${window.__env__.REACT_APP_LOGOUT_URL_B2E}`
    return false
  } else {
    dispatch(closeDialog())
    auth.signoutRedirect(redirectTo)
    window?.location?.reload()
  }
}

export const redirectToBackend = () => {
  window.location.href = `${window.__env__.REACT_APP_BACKEND_URL}/switch-from-learner`
}

export const redirectToLearningPath = (history) => (dispatch) => {
  const payload = {
    key: 'myLearningPath',
    value: [E_LEARNING_STATUS.INPROGRESS],
  }
  dispatch(setFilter(payload))
  history.push(path.learningPath)
}

export const redirectToDMS = () => {
  window.location.href = `/dms/full-form`
}
